// A "Ducks"-style collection
// https://github.com/erikras/ducks-modular-redux
import { inputStates } from 'constants/values';
import { mapValues, omit } from 'lodash';

// TODO: this file will need some massaging when we start putting in multiple applications other than seed
import productApplicationReducer from './product-applications';

// Action Types/
import { actions } from '../';

// Reducer
export default function reducer( // NOSONAR False-Positive Case statement
  state = {},
  action = {}
) {
  let applications = action.payload.zoneId && state[action.payload.zoneId].meta.applications;

  switch (action.type) {
    case actions.REMOVE_PRODUCT_APPLICATION:
      applications = omit(applications, [action.payload.applicationType]);
      return {
        ...state,
        [action.payload.zoneId]: {
          ...state[action.payload.zoneId],
          meta: {
            ...state[action.payload.zoneId].meta,
            applications: applications,
            inputState: inputStates.CHANGED
          }
        }
      };

    case 'CREATE_PRODUCT':
    case actions.UPDATE_PRODUCT_APPLICATION_PROPERTY:
      // currently only 1 application for seed and liquid, but this will change!
      applications = {
        ...applications,
        [action.payload.applicationType]:
          productApplicationReducer(applications[action.payload.applicationType], action)
      };
      return {
        ...state,
        [action.payload.zoneId]: {
          ...state[action.payload.zoneId],
          meta: {
            ...state[action.payload.zoneId].meta,
            applications: applications,
            products: action.payload.product ? [action.payload.product] : state[action.payload.zoneId].meta.products,
            inputState: inputStates.CHANGED
          }
        }
      };

    case actions.SET_SCRIPT_SOIL_COMPOSITION:
      return mapValues(state, (zone) => {
        return {...zone, meta: {...zone.meta, soilComposition: action.payload.soilComposition[zone.meta.zoneId] }};
      });

    case actions.SPLIT_ZONE:
    case actions.MERGE_ZONES:
    case actions.ADD_PIVOT_ZONE:
    case actions.ADD_SQUARE_ZONE:
    case actions.ADD_POLYGON_ZONE:
      return action.payload.zones;

    default:
      return state;
  }
}

// Action Creators - See parent duck
